<template>
  <EmptyHeader />
  <SelectPage />
</template>

<script>
import EmptyHeader from "@/components/layouts/EmptyHeader.vue";
import SelectPage from "@/components/common/SelectPage.vue";
export default {
  components: {
    EmptyHeader,
    SelectPage,
  },
};
</script>
